import styled from 'styled-components'

const WINDOWS = [
  { key: 'week', label: 'Week', hint: 'Tasks due within the next week' },
  { key: 'month', label: 'Month', hint: 'Tasks due within the next month' },
  { key: 'quarter', label: 'Quarter', hint: 'Tasks due within the next quarter' },
  { key: 'all', label: 'All', hint: 'All tasks, however far ahead' }
]

const formatCount = n => (typeof n === 'number' ? n.toLocaleString('en-GB') : null)

const TaskWindowSelector = ({ value, counts, onChange }) => {
  const active = value || 'week'

  return (
    <Group role='group' aria-label='How far ahead to load tasks'>
      <Label>Due within</Label>
      {WINDOWS.map(w => {
        const isActive = active === w.key
        const count = formatCount(counts?.[w.key])
        return (
          <Chip
            key={w.key}
            type='button'
            title={w.hint}
            $active={isActive}
            aria-pressed={isActive}
            onClick={() => onChange && onChange(w.key)}
          >
            {w.label}
            {count !== null && <Count $active={isActive}>{count}</Count>}
          </Chip>
        )
      })}
    </Group>
  )
}

export default TaskWindowSelector

const Group = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  max-width: 100%;
  box-sizing: border-box;
  align-items: center;
  gap: 4px;
  padding: 3px;
  border-radius: 22px;
  background: ${({ theme }) => theme.colors.backgroundColor || '#f3f4f6'};
  border: 1px solid ${({ theme }) => theme.colors.lightGrey || '#e5e7eb'};

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
    width: 100%;
    padding: 8px;
    border-radius: 14px;
  }
`

const Label = styled.span`
  display: inline-flex;
  align-items: center;
  align-self: stretch;
  line-height: 1;
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  padding: 0 4px 0 10px;
  white-space: nowrap;

  @media (max-width: 768px) {
    grid-column: 1 / -1;
    padding: 2px 4px 4px;
    font-size: 12px;
  }
`

const Chip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 14px;
  border-radius: 18px;
  border: 1px solid
    ${({ $active, theme }) => ($active ? (theme.colors.secondary || '#33becc') : (theme.colors.lightGrey || '#e5e7eb'))};
  background: ${({ $active, theme }) => ($active ? (theme.colors.secondary || '#33becc') : 'white')};
  color: ${({ $active, theme }) => ($active ? '#0c1229' : (theme.colors.haiti || '#0C1229'))};
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;

  &:hover {
    border-color: ${({ theme }) => theme.colors.secondary || '#33becc'};
  }

  @media (max-width: 768px) {
    justify-content: center;
    min-height: 44px;
    padding: 8px 10px;
    font-size: 14px;
  }
`

const Count = styled.span`
  font-size: 12px;
  font-weight: 800;
  min-width: 20px;
  text-align: center;
  padding: 1px 7px;
  border-radius: 999px;
  color: ${({ $active }) => ($active ? '#0c1229' : '#475569')};
  background: ${({ $active }) => ($active ? 'rgba(255, 255, 255, 0.45)' : '#eef2f6')};
`
